var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"safe_message_content",domProps:{"innerHTML":_vm._s(_vm.safeMessageHtml)},on:{"click":_vm.handleContentClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }